import clsx from 'clsx';

import { Breadcrumbs } from 'components/bredcrambs';
import { BreadcrumbsProps } from 'constants/routes-breadcrumbs';

import styles from './styles.module.css';
import { useRouter } from 'next/router';
import { Routes } from 'constants/routes';
import { IUser } from 'constants/types';
import { getItemIdentifier } from 'utils/slug';

export const useProfileBreadcrumbs = (user?: IUser): BreadcrumbsProps[] => {
  const router = useRouter();
  const { id } = router.query;

  const breadcrumbs: BreadcrumbsProps[] = [
    {
      id: 0,
      path: '/',
      title: 'Home',
    },
    {
      id: 1,
      path: '/profile',
      title: id ? 'Profile' : 'My profile',
    },
  ];

  if (id) {
    breadcrumbs.push({
      id: 2,
      path: Routes.publicProfile(getItemIdentifier(user)),
      title: user?.username ?? '',
    });
  }

  return breadcrumbs;
};

export const Main = ({ user }: { user?: IUser }) => {
  const mainClasses = clsx(styles.main, styles.main_profile);
  const profileBreadcrumbs = useProfileBreadcrumbs(user);

  return (
    <div>
      <main className={mainClasses}></main>
      <div className={styles.container_s}>
        <Breadcrumbs items={profileBreadcrumbs} />
      </div>
    </div>
  );
};
